export * from './ArrowShapeALeftIcon';
export * from './ArrowShapeALeftIcon16Light';
export * from './ArrowShapeALeftIcon16Regular';
export * from './ArrowShapeALeftIcon16Solid';
export * from './ArrowShapeALeftIcon20Light';
export * from './ArrowShapeALeftIcon20Regular';
export * from './ArrowShapeALeftIcon20Solid';
export * from './ArrowShapeALeftIcon24Regular';
export * from './ArrowShapeALeftIcon24Solid';
export * from './ArrowShapeALeftIcon32Regular';
export * from './ArrowShapeALeftIcon64Regular';
